import $ from 'jquery';
global.$ = $;
global.jQuery = $;
import Rails from 'rails-ujs';
global.Rails = Rails;
import Turbolinks from 'turbolinks';
global.Turbolinks = Turbolinks;
import '../css/base.css';